import { CHART_FREQUENCY_SETTINGS, CHART_RANGE_SETTINGS, USER_SETTINGS } from 'vio-constants';
export function getUserSettings(userSettings, consumerAPI = false) {
    const userSettingsObject = {};
    const userSettingKeys = userSettings ? Object.keys(userSettings) : [];
    for (let i = 0; i < userSettingKeys.length; i += 1) {
        const userSettingKey = userSettingKeys[i];
        const userSetting = userSettings[userSettingKey];
        const newKey = USER_SETTINGS[userSettingKey];
        if (typeof userSetting === 'string' && userSetting === 'true' || typeof userSetting === 'boolean' && userSetting) {
            userSettingsObject[newKey] = true;
        }
        else if (typeof userSetting === 'string' && userSetting === 'false' || typeof userSetting === 'boolean' && !userSetting) {
            userSettingsObject[newKey] = false;
        }
        else if (newKey === 'chartFrequency' && userSetting !== null && consumerAPI) {
            userSettingsObject[newKey] = CHART_FREQUENCY_SETTINGS[userSetting];
        }
        else if (newKey === 'chartRange' && userSetting !== null && consumerAPI) {
            userSettingsObject[newKey] = CHART_RANGE_SETTINGS[userSetting];
        }
        else if (userSetting !== null) {
            userSettingsObject[newKey] = userSetting;
        }
    }
    return userSettingsObject;
}
